<ejs-toast #toasttype id='toasttype' (beforeOpen)="onBeforeOpen($event)" (close)="close($event)"
  [position]="toastPosition"></ejs-toast>
<app-spinner></app-spinner>
<div class="container-fluid e-page-head" *ngIf="!isInformationLinks && !addInfoLinks">
  <div class="page-title row">
    <h3 class="font-weight-bold col e-mb-3">Information Links</h3>
  </div>
</div>

<!-- UI will be managed later while working on Add functionality pages -->
<!-- <div *ngIf="infoLinksList" class="space-lr">
  <div class="row">
    <div class="col" *ngIf="displayBackButton">
      <span id='msg' class="e-mb-2"></span>
      <button ejs-button cssClass="e-outline e-bigger e-css e-default" (click)="redirectToEditSettings()">
        Return to Edit Settings
      </button>
    </div>
  </div>
</div> -->

<div *ngIf="infoLinksList" class="cust-form-box e-pt-0" [ngClass]="{'e-mx-3 e-view-box e-p-0': !isInformationLinks}">
  <form [formGroup]="infoLinksForm" #form="ngForm">
    <div class="e-p-3">
      <div id="searchArea" class="form-row">
        <div class="col">
          <div class="form-row">
            <div class="e-form-group col-md-3">
              <ejs-textbox name="search" formControlName="search" id="searchTextBox" #searchTextBox placeholder="Search"
                floatLabelType="Never" cssClass="e-outline">
              </ejs-textbox>
              <!-- search icon on small device -->
              <!-- <span class="nav-icons e-icons e-search e-large d-md-none"></span> -->
            </div>
            <div class="e-form-group col e-pl-0">
              <button ejs-button (click)="getSearchData()" cssClass="e-primary e-bigger e-small e-btn e-css"
                type="button">
                Search
              </button>
              <button ejs-button (click)="resetFilters()" cssClass="e-primary e-outline e-bigger e-small e-btn e-css"
                type="button">
                Reset
              </button>
            </div>
          </div>
        </div>
        <div class="col-auto d-flex align-items-center justify-content-between" *ngIf="isInformationLinks">
          <span id='msg' class="e-mb-2"></span>
          <button ejs-button cssClass="e-outline e-primary e-bigger e-small e-css e-default"
            (click)="redirectToEditSettings()">
            Return to Main Settings
          </button>
        </div>
      </div>
    </div>
  </form>
  <hr class="e-mt-0 e-mb-3" />

  <ejs-grid class="no-border" cssClass='e-small' #informationLinksGrid id='informationLinksGrid'
    [dataSource]='ManageInfoList | async' allowPaging='true' [selectionSettings]="selectionSettings"
    [editSettings]='editSettings' [pageSettings]='initialPage' [toolbar]='toolbar' (dataBound)="onDataBound($event)"
    (toolbarClick)='toolbarClick($event)' (dataStateChange)='dataStateChange($event)' (actionBegin)='sort($event)'
    [allowSorting]='true' [height]='tableHeight'>
    <ng-template #emptyRecordTemplate>
      <span>{{ isGridLoading ? loadingGridMessage : noRecordMessage }}</span>
    </ng-template>
    <e-columns>
      <e-column width="120" headerText='Action' [showInColumnChooser]='false' isFrozen='true'
        [visible]="currentUser.UserRoleID!= Userroles.SA && path == 'edit'">
        <ng-template #template let-data>
          <div class="e-grid-action-col d-flex align-items-center justify-content-start">
            <div class="e-grid-act-btn" title="Edit Record"
              *ngIf="isInternalUser && currentUser.UserRoleID != Userroles.Investigator">
              <ng-container>
                <span class="e-icons e-edit e-pointer e-2x" (click)="actionClick(data.CompanyInformationLinkId,'edit')"
                  data-action="action" data-btninfo="edit">
                </span>
              </ng-container>
            </div>
            <div class="e-grid-act-btn" title="Delete Record"
              *ngIf="isInternalUser && currentUser.UserRoleID != Userroles.Investigator">
              <ng-container>
                <span class="e-icons e-remove e-pointer e-2x"
                  (click)="actionClick(data.CompanyInformationLinkId,'delete')"></span>
              </ng-container>
            </div>
          </div>
        </ng-template>
      </e-column>
      <e-column type='checkbox' [allowFiltering]='false' [allowSorting]='false' width='50'></e-column>
      <e-column field='CompanyInformationLinkId' [visible]='false' headerText='StatusId' [isPrimaryKey]='true'>
      </e-column>
      <e-column field='LinkDescriptText' headerText='Description' width='200'></e-column>
      <e-column field='LinkUrltext' headerText='Link' width='200' clipMode='EllipsisWithTooltip'>
        <ng-template #template let-data>
          <div>
            <a class="e-pointer" rel="noopener noreferrer" (click)="goToLink(data.LinkUrltext)"
              href="javascript:void(0);">{{data.LinkUrltext}}</a>
          </div>
        </ng-template>
      </e-column>
      <e-column field='LinkNotesText' headerText='Notes' width='200'></e-column>
    </e-columns>
  </ejs-grid>
</div>

<div *ngIf="addInfoLinks">
  <form [formGroup]="infoLinksForm" #form="ngForm" (ngSubmit)="onSubmit()">
    <div class="e-form-box bg-white e-pb-2" [ngClass]="{'add-info-link-box e-mx-3': !isInformationLinks}">
      <div class="form-row">
        <div class="e-form-group e-mb-2 col-12"
          [ngClass]="{'container-fluid e-page-head e-pt-4 e-pb-2 e-sticky-page-head e-mx-1': !isInformationLinks}">
          <h6 class="font-weight-bold e-text-base-light" [ngClass]="{'add-info-link-title': !isInformationLinks}">
            {{informationLinkTitle}}</h6>
        </div>
        <div class="e-form-group col-md-3 e-mb-2">
          <ejs-textbox placeholder="Company" readonly=true value="{{companydetails.Name}}" floatLabelType="Always"
            cssClass="e-outline">
          </ejs-textbox>
        </div>
        <div class="w-100"></div>
        <div class="e-form-group col-md-6 e-mb-2">
          <div class="multiline">
            <ejs-textbox [multiline]='true' floatLabelType='Always' cssClass="e-outline e-mandetory"
              placeholder='Description' formControlName="description"></ejs-textbox>
          </div>
          <div *ngIf="submitted && formControl.description.errors?.required" class="e-small error-msg e-block">
            The Description field cannot be blank. Please enter a valid description.
          </div>
        </div>
        <div class="w-100"></div>
        <div class="e-form-group col-md-6 e-mb-2">
          <ejs-textbox placeholder='Link' floatLabelType="Always" cssClass="e-outline e-mandetory"
            formControlName="link"></ejs-textbox>
          <div *ngIf="submitted && formControl.link.errors?.required" class="e-small error-msg e-block">
            The Link field cannot be blank. Please enter a valid url link.
          </div>
        </div>
        <div class="w-100"></div>
        <div class="e-form-group col-md-6 e-mb-2">
          <div class="multiline">
            <ejs-textbox [multiline]='true' floatLabelType='Always' cssClass="e-outline" placeholder='Notes'
              formControlName="notes">
            </ejs-textbox>
          </div>
        </div>
      </div>
    </div>
    <div class="e-sticky-page-footer" [ngClass]="{'e-mx-3': !isInformationLinks}">
      <div class="col-12 e-pb-3 bg-white e-page-footer-btn-box">
        <hr class="e-mt-0" />
        <button ejs-button cssClass="e-primary e-bigger e-small e-btn e-css" type="submit">
          Save
        </button>
        <button ejs-button cssClass="e-outline e-primary e-bigger e-small e-css e-default" (click)="showAddList()">
          Cancel
        </button>
      </div>
    </div>
  </form>
  <div class="outerDiv" [ngClass]="{'e-mx-3': !isInformationLinks}">
    <div class="innerDiv"><span class="note-text"><strong>Note</strong>: The Link field must be an http or https
        url.</span>
    </div>
  </div>
</div>

<!-- <div *ngIf="addInfoLinks" class="container-fluid e-pt-3 e-page-content">
  <div class="container-fluid e-page-head">
    <div class="page-title row">
      <h5 class="e-text-base font-weight-bold col e-pb-2">{{informationLinkTitle}}</h5>
    </div>
  </div>
  <form [formGroup]="infoLinksForm" #form="ngForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-xl-8">
        <div class="row">
          <div class="col-sm-6 e-form-group e-mb-2">
            <ejs-textbox placeholder="Company" readonly=true value="{{companydetails.Name}}" floatLabelType="Auto">
            </ejs-textbox>
          </div>
          <div class="w-100"></div>
          <div class="col-sm-6 e-form-group e-mb-2">
            <div class="multiline">
              <ejs-textbox [multiline]='true' floatLabelType='Auto' placeholder='Description'
                formControlName="description"></ejs-textbox>
            </div>
            <div *ngIf="submitted && formControl.description.errors">
              <span *ngIf="formControl.description.errors?.required" class="e-small error-msg e-block">
                The Description field cannot be blank. Please enter a valid description.
              </span>
            </div>
          </div>
          <div class="w-100"></div>
          <div class="col-sm-6 e-form-group e-mb-2">
            <ejs-textbox placeholder='Link' floatLabelType="Auto" formControlName="link"></ejs-textbox>
            <div *ngIf="submitted && formControl.link.errors">
              <span *ngIf="formControl.link.errors?.required" class="e-small error-msg e-block">
                The Link field cannot be blank. Please enter a valid url link.
              </span>
            </div>
          </div>
          <div class="col-sm-12 e-form-group e-mb-2">
            <div class="multiline">
              <ejs-textbox [multiline]='true' floatLabelType='Auto' placeholder='Notes' formControlName="notes">
              </ejs-textbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <hr />
        <div class="e-mt-3">
          <button ejs-button cssClass="e-primary e-bigger e-btn e-css" type="submit">
            Save
          </button>
          <button ejs-button cssClass="e-outline e-bigger e-css e-default" (click)="showAddList()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </form>
  <div class="outerDiv e-mt-2">
    <div class="innerDiv"><span class="e-text e-primary"><strong>Note</strong>: The Link field must be an http or https
        url.</span>
    </div>
  </div>
</div> -->